// extracted by mini-css-extract-plugin
export default {"productGallery":"RN-z","inQuickShop":"SN-z"};